import BaseServiceCrud from './BaseServiceCrud';

export default class ActionService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'action-manage';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            hide_expired: criteria.hideExpired,
            locale: criteria.locale,
            title: criteria?.title,
            coinsFrom: criteria?.coinsFrom,
            coinsTo: criteria?.coinsTo,
            first_result: criteria.firstResult,
            max_results: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    
    removeQRCode(id) {
        return this.fetch(`${this.domain}/${this.path}/${id}`, {
            method: 'DELETE',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    publish(id) {
        return this.fetch(`${this.domain}/${this.path}/publish/${id}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    publishToCompanies(id, request) {
        return this.fetch(`${this.domain}/${this.path}/publish/${id}/companies`, {
            method: 'PUT',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

}
